'use client';
import { jsx } from 'react/jsx-runtime';
import { SwanMenuContextProvider } from './menu.context.js';
import { useComponentStylesLoaded } from '../../hooks/use-component-styles-loaded.js';
import { CollectionContextProvider } from '../../contexts/internal/collection/collection.component.js';
import { SWAN_STYLE_KEY_MAP } from '../head/stylesheets.component.js';

function Menu(c) {
    let { children: m, onChange: i } = c;
    return useComponentStylesLoaded('Menu', [
        SWAN_STYLE_KEY_MAP.popover,
        SWAN_STYLE_KEY_MAP.listbox
    ]), jsx(CollectionContextProvider, {
        children: jsx(SwanMenuContextProvider, {
            onAction: i,
            children: m
        })
    });
}

export { Menu };
